<template>
  <div class="row">
    <div class="col-6">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <Form ref="redeForm" @submit="payer" :validation-schema="redeSchema">
          <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
            <h5 class="card-title fw-bold mb-15 mb-lg-20 mb-xl-25"></h5>

            <div v-show="messagePromotion != ''" class="alert alert-primary fs-md-15 fs-lg-16" role="alert">
              {{ messagePromotion }}
            </div>
            <div v-show="messagePenalite != ''" class="alert alert-danger fs-md-15 fs-lg-16" role="alert">
              {{ messagePenalite }}
            </div>
            <div v-show="messageDerniereRedevance != ''" class="alert alert-primary fs-md-15 fs-lg-16" role="alert">
              {{ messageDerniereRedevance }}
            </div>

            <div class="border p-2 p-lg-4 border-dark border-opacity-10">
              <!-- Abonnement -->
              <div class="mb-15 mb-md-20">
                <label for="abonnement" class="form-label fw-medium text-black">
                  ABONNEMENTS <span class="text-danger">*</span>
                </label>
                <Field name="abonnement" v-model="abonnement" class="form-control shadow-none fs-md-15 text-black"
                  v-slot="{ field }">
                  <Multiselect
                    v-model="field.value"
                    v-bind="field"
                    :filter-results="false"
                    :min-chars="2"
                    :resolve-on-load="false"
                    :delay="0"
                    :searchable="true"
                    :options-limit="300"
                    :options="async (query) => {
                      const results = await getAbonnementFromBaseWithKey(query);
                      if (results && results.length > 0) {
                        return results;
                      } else if (query.length >= 3) {
                        return [{ value: '', label: 'Aucun enregistrement trouvé' }];
                      } else {
                        return [];
                      }
                    }"
                    noOptionsText="Tapez au moins deux caractères"
                    placeholder="Rechercher un abonnement"
                  />
                </Field>
                <ErrorMessage name="abonnement" class="text-danger" />
              </div>

              <!-- Mode de paiement -->
              <div class="mb-15 mb-md-20">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="form-label fw-medium text-black">
                    Mode de paiement <span class="text-danger">*</span>
                  </label>
                  <Field name="mode" v-slot="{ field }" v-model="mode">
                    <Multiselect
                      :options="modeOptions"
                      :searchable="true"
                      v-model="field.value"
                      v-bind="field"
                      placeholder="Sélectionner un mode"
                    />
                  </Field>
                  <ErrorMessage name="mode" class="text-danger" />
                </div>
              </div>

              <!-- Durée et Montant -->
              <div class="row">
                <div class="col-md-6">
                  <label for="duree" class="form-label fw-medium text-black">
                    Durée abonnement <span class="text-danger">*</span>
                  </label>
                  <Field name="montantRemise" v-model="montantRemise" class="d-none" />
                  <Field name="montantPenalite" v-model="montantPenalite" class="d-none" />
                  <Field name="duree" v-model="duree" type="number"
                    class="form-control shadow-none fs-md-15 text-black" />
                  <ErrorMessage name="duree" class="text-danger" />
                </div>

                <div class="col-md-6">
                  <label for="montant" class="form-label fw-medium text-black">
                    Montant <span class="text-danger">*</span>
                  </label>
                  <Field name="montant"
                         v-model="montant"
                         :disabled="!isModeSpecifique"
                         type="number"
                         class="form-control shadow-none fs-md-15 text-black"
                         :class="{ 'bg-light': !isModeSpecifique }" />
                  <ErrorMessage name="montant" class="text-danger" />
                  <small v-if="isModeSpecifique" class="text-muted d-block mt-1">
                    Vous pouvez modifier le montant pour ce mode de paiement
                  </small>
                </div>
              </div>

              <!-- Champs spécifiques pour Chèque / Virement -->
              <div v-if="isModeSpecifique" class="mt-4">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Date d'opération <span class="text-danger">*</span>
                      </label>
                      <Field name="dateOperation" type="date"
                             class="form-control shadow-none rounded-0 text-black" />
                      <ErrorMessage name="dateOperation" class="text-danger" />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 mb-3">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Justificatif / Contenu <span class="text-danger">*</span>
                      </label>
                      <Field name="contenu" as="textarea" rows="6"
                             placeholder="Numéro de chèque, référence virement, etc."
                             class="form-control shadow-none rounded-0 text-black" />
                      <ErrorMessage name="contenu" class="text-danger" />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Pièce jointe <span class="text-danger">*</span>
                      </label>
                      <Field name="urlImage" type="file"
                             accept="image/jpeg, image/png, application/pdf"
                             @change="onFileChange"
                             class="form-control shadow-none fs-md-15 text-black" />
                      <ErrorMessage name="urlImage" class="text-danger" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br>
            <div class="text-center">
              <div class="col-md-6">
                <div class="d-flex align-items-right justify-content-center">
                  <button
                    class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                    type="submit">
                    Ajouter
                  </button>
                  <router-link to="/liste-paiements"
                    class="btn btn-danger transition border-0 lh-1 fw-medium">
                    <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                    Annuler
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>

    <!-- Tableau des redevances -->
    <div class="col-6">
      <div class="card mb-25 border-0 rounded-0 bg-white">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between">
            <h6 class="card-title fw-bold mb-0">REDEVANCES</h6>
            <div class="card-select mt-10 mt-sm-0 mb-10 mb-sm-0 d-flex align-items-center ps-10 pe-10 pt-5 pb-5">
              <span class="fw-medium text-muted me-8">TOTAL IMPAYE : {{ somRedevance }}</span>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">#</th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Année</th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Loyer</th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Date Redevance</th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Etat</th>
                </tr>
              </thead>
              <tbody v-if="redevances">
                <tr v-for="(redv, index) in redevances" :key="index">
                  <th class="shadow-none lh-1 fw-bold ps-0">{{ index + 1 }}</th>
                  <td class="shadow-none lh-1 fw-semibold text-dark">{{ redv.annee }}</td>
                  <td class="shadow-none lh-1 fw-semibold text-dark">{{ redv.montant }}</td>
                  <td class="shadow-none lh-1 fw-medium text-body-tertiary">{{ format_date(redv.dateRedevance) }}</td>
                  <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                    <span class="badge text-outline-danger">En attente</span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <th class="shadow-none lh-1 fw-bold ps-0" colspan="5">AUCUNE REDEVANCE TROUVÉE</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>





<script lang="ts">
import { defineComponent, ref, watch, computed, onMounted, reactive, toRef } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success, format_date, getUrlApiForFiles, openAndPrint } from '@/utils/utils';
import { useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect';
import axios from 'axios';
import { Redevance2 } from '@/models/Redevance';
import { openKkiapayWidget, addKkiapayListener, removeKkiapayListener } from 'kkiapay';
import Swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { KKIAPAY } from '@/models/KKIAPAY';

// Interface pour typer les options de mode
interface ModeOption {
  value: number;
  label: string;
  estSpecifique: boolean;
}

export default defineComponent({
  name: 'Add2Reabonnement',
  components: { Form, Field, ErrorMessage, Multiselect },
  setup() {
    const router = useRouter();

    // Références réactives
    const bureau = ref(null);
    const abonnement = ref<number | null>(null);
    const messagePromotion = ref('');
    const messagePenalite = ref('');
    const messageDerniereRedevance = ref('');
    const anneeDerniereRedevance = ref<number | null>(null);
    const tauxPromotion = ref(0);
    const categorieAbonneId = ref(0);
    const montantPenalite = ref(0);
    const montantRemise = ref(0);
    const selectedFile = ref<File | null>(null);

    const redevances = ref<Redevance2[]>([]);
    const duree = ref(1);
    const loyer = ref(0);
    const somRedevance = ref(0);
    const montant = ref(0);

    // Modes de paiement avec typage fort
    const modeOptions = ref<ModeOption[]>([]);
    const mode = ref<number | null>(null);

    // Détection du mode spécifique
    const isModeSpecifique = computed(() => {
      const selected = modeOptions.value.find((opt) => opt.value === mode.value);
      return selected?.estSpecifique === true;
    });

    // Schema de validation conditionnelle
    const redeSchema = Yup.object().shape({
      abonnement: Yup.number().required("L'abonnement est obligatoire"),
      mode: Yup.number().required('Le mode est obligatoire'),
      duree: Yup.number().min(1, 'La durée doit être ≥ 1').required('La durée est obligatoire'),
      montant: Yup.number().typeError('Renseigner une valeur numérique').required('Le montant est obligatoire'),

      dateOperation: Yup.date().when('mode', {
        is: (val: number) => modeOptions.value.find((m) => m.value === val)?.estSpecifique === true,
        then: (schema) => schema.required("La date d'opération est obligatoire pour ce mode de paiement"),
        otherwise: (schema) => schema.nullable().optional(),
      }),

      contenu: Yup.string().when('mode', {
        is: (val: number) => modeOptions.value.find((m) => m.value === val)?.estSpecifique === true,
        then: (schema) => schema.required('Le justificatif est obligatoire pour ce mode de paiement'),
        otherwise: (schema) => schema.optional(),
      }),
    });

    // Chargement des modes de paiement
    const fetchModePaiement = async () => {
      try {
        const response = await axios.get('/modepaiements');
        const modesData = response.data.data.data;
        modeOptions.value = modesData.map((m: any) => ({
          value: m.id,
          label: m.libelle,
          estSpecifique: m.estSpecifique === true || m.estSpecifique === 1 || m.estSpecifique === '1',
        }));
      } catch (err) {
        console.error(err);
      }
    };

    // Mise à jour automatique du montant
    const updateMontant = () => {
      if (isModeSpecifique.value) {
        montant.value = somRedevance.value + (montantPenalite.value - (montantPenalite.value * tauxPromotion.value) / 100);
      } else {
        montant.value = (loyer.value || 0) * (duree.value || 0) + (montantPenalite.value - (montantPenalite.value * tauxPromotion.value) / 100);
      }
    };

    watch(mode, updateMontant);
    watch(duree, () => !isModeSpecifique.value && updateMontant());

    // Gestion fichier
    const onFileChange = (e: any) => {
      const file = e.target.files[0];
      const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
      if (file && !allowedTypes.includes(file.type)) {
        e.target.value = '';
        error('Fichier non valide. Veuillez sélectionner une image ou un PDF.');
      } else {
        selectedFile.value = file;
      }
    };

    const getAbonnementFromBaseWithKey = async (key: string) => {
      if (!key) return [];
      const response = await axios.post('/bureau/abonnements/abonne', { bureau: bureau.value, cle: key });
      const data = response.data.data;
      return data.map((abo: any) => ({
        value: abo.id,
        label: abo.boite
          ? `${abo.refAbo} ${abo.abonne?.nomComplet} [${abo.abonne?.telephone}] [${abo.boite?.refBoite}] [${abo.boite?.adressePostale?.adresse_postale}]`
          : `${abo.refAbo} ${abo.abonne?.nomComplet} [${abo.abonne?.telephone}] [${abo.adresseVirtuelle}]`,
      }));
    };

    const fetchAbonnement = async (key: number) => {
      if (!key) return null;
      const response = await axios.get('/abonnements/' + key);
      return response.data.data;
    };

    const fetchRedevances = async (key: number) => {
      if (!key) return [];
      const response = await axios.get('/redev/non/abonnement/' + key);
      return response.data.data;
    };

    // Watch sur abonnement
    watch(abonnement, async (newValue) => {
      if (newValue) {
        const lastRedevancePayer = await fetchLastRedevancePayer(newValue);
        console.log("Redevance payée la plus récente ===> ", lastRedevancePayer);

        const val = await fetchAbonnement(newValue);
        loyer.value = val?.loyer || 0;

        if (tauxPromotion.value > 0) {
          montantRemise.value = (loyer.value * tauxPromotion.value) / 100;
          loyer.value -= montantRemise.value;
        }

        redevances.value = await fetchRedevances(newValue);
        somRedevance.value = 0;
        montantPenalite.value = 0;
        messagePenalite.value = '';

        redevances.value.forEach((r: any) => {
          somRedevance.value += r.montant || 0;
          const today = new Date();
          const currentYear = today.getFullYear();
          const currentMonth = String(today.getMonth() + 1).padStart(2, '0');
          const currentDay = String(today.getDate()).padStart(2, '0');
          const currentYearMonthDay = `${currentYear}-${currentMonth}-${currentDay}`;
          const janFirstRedevance = new Date(`${r.annee}-01-01`);
          const marsDate = new Date(`${currentYear}-03-01`);
          const redevanceMonthDay = new Date(`${r.annee}-${currentMonth}-${currentDay}`);
          // const redevanceDate = new Date(redevanceMonthDay);
          console.log("Dates pour pénalité 1===> ", janFirstRedevance.toISOString().split('T')[0]);
          console.log("Dates pour pénalité 2===> ", marsDate.toISOString().split('T')[0]);
          console.log("Dates pour pénalité 3===> ", redevanceMonthDay.toISOString().split('T')[0]);
          
          if ( janFirstRedevance < marsDate ) {
            
            if(currentYear == r.annee){
              if(redevanceMonthDay >= marsDate){
                messagePenalite.value = 'Une pénalité de 3 000 F sera appliquée à cause de(s) arriéré(s) impayé(s)';
                montantPenalite.value = 3000;
              }
            } else {
              messagePenalite.value = 'Une pénalité de 3 000 F sera appliquée à cause de(s) arriéré(s) impayé(s)';
              montantPenalite.value = 3000;
            }
            
          }
        });

        // cas ou je n'ai pas d'arrieré
        if(redevances.value.length === 0 && anneeDerniereRedevance.value !== null && anneeDerniereRedevance.value < new Date().getFullYear()){
          const today = new Date();
          const currentYear = today.getFullYear();
          const marsDate = new Date(`${currentYear}-03-01`);
          if( today >= marsDate){
            messagePenalite.value = 'Une pénalité de 3 000 F sera appliquée';
            montantPenalite.value = 3000;
          }
        }
        if(redevances.value.length === 0 && anneeDerniereRedevance.value === null){
          const today = new Date();
          const currentYear = today.getFullYear();
          const marsDate = new Date(`${currentYear}-03-01`);
          if( today >= marsDate){
            messagePenalite.value = 'Une pénalité de 3 000 F sera appliquée';
            montantPenalite.value = 3000;
          }
        }

        // if(redevances.value.length === 0 && anneeDerniereRedevance.value === null){
        //     messagePenalite.value = 'Une pénalité de 3 000 F sera appliquée';
        //     montantPenalite.value = 3000;
        //   }
        // }

        updateMontant();
      } else {
        messagePromotion.value = '';
        messagePenalite.value = '';
        tauxPromotion.value = 0;
        montantPenalite.value = 0;
        somRedevance.value = 0;
        redevances.value = [];
        montant.value = 0;
        messageDerniereRedevance.value = '';
        anneeDerniereRedevance.value = null;
      }
    });

    // Fonctions de paiement (inchangées)
    const check = reactive({ typeError: 'RAS', idTransaction: 0 });

    const successHandler = async (response: any, values: any, { resetForm }: any) => {
      check.typeError = 'SUCCESS';
      check.idTransaction = response.transactionId;
      values.idTransaction = check.idTransaction;
      values.check = check;
      if (check.typeError === 'SUCCESS') await addAPaiementRedev(values, { resetForm });
    };

    const failHandler = (response: any) => {
      check.typeError = 'ECHOUE';
      check.idTransaction = response.transactionId;
    };

    const payer = async (values, { resetForm }) => {
      if (values.mode == 1) {
        try {
          const result = await Swal.fire({
            text: "Vous êtes sur le point de faire un paiement d'une somme de " + values.montant + " F CFA",
            icon: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            confirmButtonText: "Payer",
            cancelButtonText: `Annuler`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            heightAuto: false,
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });

          if (result.isConfirmed) {
            values["check"] = KKIAPAY.check;
            await addAPaiementRedev(values, { resetForm });
          }

        } catch (error) {
          // 
        }
        resetForm();
      }
      if (values.mode == 2) {
        try {
          const result = await Swal.fire({
            text: "Vous êtes sur le point de faire un paiement d'une somme de " + values.montant + " F CFA",
            icon: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            confirmButtonText: "Payer",
            cancelButtonText: `Annuler`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            heightAuto: false,
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });

          if (result.isConfirmed) {
            KKIAPAY.kkia(values.montant);
            await new Promise<void>((resolve) => {
              addKkiapayListener('failed', (event) => {
                failHandler(event);
                resolve();
              });

              addKkiapayListener('success', (event) => {
                successHandler(event, values, { resetForm });
                resolve();
              });

              const checkRef = toRef(check);

              let resolved = false;

              const intervalId = setInterval(() => {
                if (!resolved && checkRef.value.typeError !== "RAS") {
                  clearInterval(intervalId);
                  resolved = true;
                  resolve();
                }
              }, 500);
            });
          }


        } catch (error) {
          //
        }
      }
    };

    const fetchLastRedevancePayer = async (abonnementId: number) => {
      try {
        const response = await axios.get(`/redevance/paie/last/last/${abonnementId}`);
        console.log("Redevance payée la plus récente ===> ", response.data.data.annee);
        if(response.data.data && response.data.data.annee){
        anneeDerniereRedevance.value = response.data.data.annee;
        messageDerniereRedevance.value = `La dernière redevance payée est celle de l'année ${response.data.data.annee}`;
        }
        return response.data.data;
      } catch (err: any) {
        if(err.request && err.request.status === 400){
          messageDerniereRedevance.value = `Aucune redevance payée trouvée pour cet abonnement.`;
          return null;
        }
        console.log("Erreur lors de la récupération de la dernière redevance payée : ", err);
        console.error(err);
        return null;
      }
    };

    const addAPaiementRedev = async (values, { resetForm }) => {
      await ApiService.post("/paiement_redevance/by/redevance/S", values)
        .then(async ({ data }) => {
          console.log("Retour ===> ",data);
          if (data.code == 201) {
            success(data.message);
            var fullUrl = "Recu";
            var nom = data.data.resPaiement.refPaiement + ".pdf";
            resetForm();
            router.push({ name: "ListePaiementPage" });
            const maFonction = async () => {
              const result = await Swal.fire({
                html: `<div>Cliquer sur le bouton Aperçu ci-dessous pour avoir un aperçu de votre document</div>`,
                icon: "success",
                buttonsStyling: true,
                confirmButtonText: "Aperçu",
                showCancelButton: false,
                cancelButtonText: `Fermer`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                heightAuto: false,
                customClass: {
                  confirmButton: "btn btn-success",
                  cancelButton: "btn btn-warning",
                },
              });

              if (result.isConfirmed) {
                openNewWindow(data.data)
              }
            }

            // Utiliser setTimeout pour exécuter la fonction après la durée spécifiée
            setTimeout(maFonction, 3000);

          }
        }).catch(({ response }) => {
          error(response.data.message);
        });
    };


    const openNewWindow = (data: any) => {
      openAndPrint(getUrlApiForFiles('Recu', data.resPaiement.refPaiement + '.pdf'));
    };

    onMounted(async () => {
      await fetchModePaiement();
      // console.log("bonjoue", new Date().toISOString().split('T')[0]);
      // await fetchBoitesByBureau(); si besoin
    });

    return {
      redeSchema,
      getAbonnementFromBaseWithKey,
      onFileChange,
      payer,
      somRedevance,
      bureau,
      abonnement,
      selectedFile, 
      isModeSpecifique,
      redevances,
      modeOptions,
      mode,
      montant,
      duree,
      format_date,
      messagePromotion,
      messagePenalite,
      montantPenalite,
      montantRemise,
      tauxPromotion,
      messageDerniereRedevance
    };
  },
});
</script>